import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '@redux/hooks';
import { filterActions, getCurrentPage, getParams, getTemplate } from '@entities/Filter';

export const useGenerateFetchStr = () => {
  const dispatch = useAppDispatch();
  const params = useAppSelector(getParams);
  const page = useAppSelector(getCurrentPage);
  const template = useAppSelector(getTemplate);
  useEffect(() => {
    dispatch(filterActions.setStrParams());
  }, [params, page, template]);
};
